// extracted by mini-css-extract-plugin
module.exports = {"root":"countdown-module--root--325sj","wrapper":"countdown-module--wrapper--jIjFc","colon":"countdown-module--colon--un9hS"};